





















import {Component, Mixins} from 'vue-property-decorator';
import CommonButton from '@/components/button/CommonButton.vue';
import CheckboxInput from '@/components/input/CheckboxInput.vue';
import BooleanCheckboxInput from '@/components/input/BooleanCheckboxInput.vue';
import CheckFilterMixin from '@/components/table/filter/CheckFilterMixin';

@Component({
    components: {BooleanCheckboxInput, CheckboxInput, CommonButton},
    mixins: [CheckFilterMixin]
})
export default class CheckFilter extends Mixins<CheckFilterMixin>(CheckFilterMixin) {
}
